import { Flex, Text } from "@chakra-ui/react";
import { RelatorioComposicaoContasItem } from "core/features/relatorios/conta-com-composicoes/typings";
import colors from "core/resources/theme/colors";
import TableHeaderRow from "./components/TableHeaderRow";
import TableItemRow from "./components/TableItemRow";
import { formatMoney } from "infra/helpers/number";
import { OperacaoEnum } from "resources/enums/conta";

export interface TabelaItemComposicaoContasProps {
  item: RelatorioComposicaoContasItem;
  operacao: OperacaoEnum;
}

function TabelaItemComposicaoContas({
  item,
  operacao,
}: TabelaItemComposicaoContasProps) {
  return (
    <Flex maxW="100%" flexDir="column">
      <Flex
        bg={colors.black100}
        gridGap={4}
        py={3}
        pr={6}
        fontWeight="medium"
        fontSize={12}
      >
        <TableHeaderRow />
      </Flex>
      <Flex w="100%" flexDir="column">
        {item.composicoes.map((composicao, index) => (
          <Flex
            key={composicao.id}
            bg={index % 2 === 0 ? "white" : colors.black100}
            gridGap={4}
            py={3}
            pr={6}
          >
            <TableItemRow composicao={composicao} operacao={operacao} />
          </Flex>
        ))}

        <Flex
          bg={item.composicoes.length % 2 === 0 ? "white" : colors.black100}
          gridGap={1}
          py={3}
          pr={6}
          fontWeight="bold"
          justifyContent="space-between"
          pl={7}
        >
          <Text>Total</Text>
          <Text>{formatMoney(item.valorTotal, true)}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default TabelaItemComposicaoContas;
